// §34.10 / §9.1 — Snip's registration stub.
//
// **Manifest and thunk only** (D-511). The chunk is emitted as `lazy.Snip-<hash>.js` and excluded
// from the service-worker precache by the same exact-prefix rule as `game.` (§34.16, D-199).
import type { InProcessApp, SnipShellAccess } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';
import { COPY } from '@/copy';
import { SNIP_WINDOW } from '@/config';

export function createSnipApp(access: SnipShellAccess): InProcessApp {
  return createLazyApp({
    app: {
      id: 'snip',
      name: COPY.snip.title,
      // §34.1 (D-497) — the wave's launcher home.
      category: 'Utilities',
      // Hue from §14's ladder: a cool teal, distinct from Voice's red and Archive's amber.
      icon: { glyph: 'scissors', hue: 190 },
      keywords: ['screenshot', 'capture', 'snip', 'clip', 'grab', 'annotate'],
      // No `fileTypes`: Snip *writes* PNGs and never opens one — Photos is the registered viewer
      // (§11.7), and M63.5's flow ends by launching it through the kernel rather than importing it.
      window: { ...SNIP_WINDOW, multiWindow: false },
      // §34.10 — the jump list, in the order the mode strip shows them. The ids are the `SnipMode`
      // values themselves, so the view's handler needs no second vocabulary to map between.
      jumpList: [
        { id: 'region', label: COPY.snip.modeRegion },
        { id: 'window', label: COPY.snip.modeWindow },
        { id: 'full', label: COPY.snip.modeFull },
      ],
    },
    load: () => import('./Snip'),
    props: { access },
  });
}
